module.exports = __webpack_public_path__ + "static/media/snickra.d89495e8.mp3";